import { Component, Input, OnInit } from "@angular/core";
import { ChangeDetectorRef, ViewChild } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { UserService } from "./services/user/user.service";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import {
  BsModalRef,
  BsModalService,
  ModalDirective,
} from "ngx-bootstrap/modal";
import { DataService } from "./services/data.service";
import { AlertService } from "./services/alert/alert.service";
import { User } from "./services/user/user";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    standalone: false
})
export class AppComponent implements OnInit {
  title = "tmssclient";
  idleState = "Not started.";
  timedOut = false;
  lastPing?: Date = null;
  @Input() currentUser: User;

  @ViewChild("timeoutmodal", { static: true })
  public timeoutmodal: ModalDirective;

  /**
   *
   * @param: {Router} router
   * @param: {UserService} userService
   * @param: {Idle} idle
   * @param: {Keepalive} keepalive
   * @param: {BsModalService} modalService
   * @param: {DataService} dataService
   * @param: {AlertService} alertService
   * @param: {ChangeDetectorRef} cdr
   */
  constructor(
    private router: Router,
    private userService: UserService,
    private idle: Idle,
    private keepalive: Keepalive,
    private modalService: BsModalService,
    private dataService: DataService,
    private alertService: AlertService,
    private cdr: ChangeDetectorRef
  ) {
    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(30 * 60); // dev/test/prod
    // idle.setIdle(30*5); // local test
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(60); // dev/test/prod
    // idle.setTimeout(5); // test
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // this is idle impl

    idle.onIdleEnd.subscribe(() => (this.idleState = "No longer idle."));
    idle.onTimeout.subscribe(() => {
      this.idleState = "Timed out!";
      this.timedOut = true;
      this.timeoutmodal.hide();
      this.logout();
    });
    idle.onIdleStart.subscribe(
      () => (this.idleState = "Your session is idle.")
    );
    idle.onTimeoutWarning.subscribe((countdown) => {
      // Do not show timer if user logged out using the link in header. We remove Item if logged out.
      if (JSON.parse(localStorage.getItem("currentUser")) !== null) {
        this.idleState =
          "Your session will time out in " + countdown + " seconds.";
        this.timeoutmodal.show();
      }
    });
    // sets the ping interval to 120 seconds
    keepalive.interval(120);

    // send keep alive to server
    keepalive.onPing.subscribe(() => {
      this.lastPing = new Date();
      this.userService.keepAlive();
    });

    this.reset();
  }

  ngOnInit() {
    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
  }

  logout() {
    this.timeoutmodal.hide();
    this.currentUser = null;
    this.userService.logout("app");
  }
}

// Google Analytics for all pages in TMSS 2.0
declare let gtag: Function;

export class GoogleAnalytics {
  constructor(public router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag("config", "G-F2NXJFH9T2", {
          page_path: event.urlAfterRedirects,
        });
        gtag("config", "UA-33523145-1", { send_page_view: false });
      }
    });
  }
}
